module.exports = __webpack_public_path__ + "static/media/icon_direcionador_orange.31227c45.svg";